import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const AssetPage = lazy(() => import('../../pages/Assets/AssetsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<AssetPage />} />
    </Routes>
  );
}

export default PagesRoute;
